import { createReducer } from '../../utils';
import * as Types from './types';

const initialState = {
  postingId: '',
  loading: false,
  error: null,
  response: null,
  lastResponse: null,
  saveAndExit: false,
  savedFromModal: false
};

const savePostingReducer = createReducer(initialState)({
  [Types.SAVE_POSTING_DB]: (state, action) => ({
    ...state,
    error: null,
    loading: true,
    saveAndExit: action.meta.saveAndExit,
    savedFromModal: action.meta.savedFromModal
  }),
  [`${Types.SAVE_POSTING_DB}_COMPLETED`]: (state, action) => ({
    ...state,
    loading: false,
    saveAndExit: false,
    savedFromModal: false,
    lastResponse: state.response,
    response: action.payload,
    postingId: action.payload.postingId
  }),
  [`${Types.SAVE_POSTING_DB}_FAILED`]: (state, action) => ({
    ...state,
    loading: false,
    saveAndExit: false,
    savedFromModal: false,
    error: action.payload.data
  }),
  [`${Types.SAVE_POSTING_DB}_CLEAR_ERROR`]: state => ({
    ...state,
    error: null
  })
});

export { savePostingReducer };
